<template>
  <div class="row">
    <div class="col-12">
      <ul class="preview-ul">
        <li class="form-line">
          <div class="form-line-item">
            <span>{{ $t("booking.index.checkin") }}:</span>
            <span>{{ booking.checking ? booking.checking : '-' }}</span>
          </div>
          <div class="form-line-item">
            <span>{{ $t("booking.index.checkout") }}:</span>
            <span>{{ booking.checkout ? booking.checkout : '-' }}</span>
          </div>
          <div class="form-line-item">
            <span>{{ $t("input.number_of_adults") }}:</span>
            <span>{{ booking.nbr_adults ? booking.nbr_adults : '-' }}</span>
          </div>
          <div class="form-line-item">
            <span>{{ $t("input.number_of_children") }}:</span>
            <span>{{ booking.nbr_children ? booking.nbr_children : '-' }}</span>
          </div>
          <div class="form-line-item">
            <span>{{ $t("booking.index.guest") }}:</span>
            <span>{{ booking.guest.first_name && booking.guest.last_name ? `${booking.guest.first_name} ${ booking.guest.last_name }` : '-' }}</span>
          </div>
          <div class="form-line-item">
            <span>{{ $t("input.arrival_time") }}:</span>
            <span>{{ booking.time_in ? booking.time_in : '-'}}</span>
          </div>
          <div class="form-line-item">
            <span>{{ $t("input.departure_time") }}:</span>
            <span>{{ booking.time_out ? booking.time_out : '-'}}</span>
          </div>
        </li>
        <li class="form-line">
          <div class="form-group form-material">
            <label for="checkin-form-email" class="control-label">
              {{ $t("input.email") }}
            </label>
            <input type="email" class="form-control" id="checkin-form-email" v-model="booking.guest.alternative_email">
          </div>
        </li>
        <li class="form-line">
          <div class="form-group form-material">
            <label for="checkin-form-phone" class="control-label">
              {{ $t("input.phone") }}
              <span class="required">*</span>
            </label>
            <input type="text" class="form-control" id="checkin-form-phone" v-model="booking.guest.alternative_phone">
          </div>
        </li>
        <li class="form-line">
          <div class="form-group form-material">
            <label for="checkin-form-time-in" class="control-label">
              {{ $t("input.checkin_time") }}
              <span class="required">*</span>
            </label>
            <select id="checkin-form-time-in" class="form-control" v-model="booking.time_in">
              <option v-for="i in timeInHours" :value="i">{{ i }}</option>
            </select>
          </div>
        </li>
        <li class="form-line">
          <div class="form-group form-material">
            <label for="checkin-form-timeout" class="control-label">
              {{ $t("input.checkout_time") }}
              <span class="required">*</span>
            </label>
            <select id="checkin-form-timeout" class="form-control" v-model="booking.time_out">
              <option v-for="i in timeOutHours" :value="i">{{ i }}</option>
            </select>
          </div>
        </li>
        <li class="form-line">
          <div class="form-group">
            <label for="checkin-form-comments" class="control-label">
              {{ $t("booking.detail.events.comments") }}
              <span class="required">*</span>
            </label>
            <textarea
              name="checkin_form_comment"
              class="form-control"
              id="checkin-form-comments"
              cols="100" rows="6"
              v-if="booking.extra_data_from_form"
              v-model="booking.extra_data_from_form.comments"
            >
            </textarea>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
        name: "FormDetails",
        props: [
          'booking',
          'timeInHours',
          'timeOutHours'
        ]
    }
</script>



// WEBPACK FOOTER //
// FormDetails.vue?dfc8d538